import Vue from 'vue'

Vue.filter('currency', value => {
    let val = (value/1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
});

Vue.filter('cpf', value => {
    const arr = value.split('')
    arr.splice(3, 0, '.')
    arr.splice(7, 0, '.')
    arr.splice(11, 0, '-')
    return arr.join('')
});

Vue.filter('cep', value => {
    if(value) {
        const arr = value.split('')
        arr.splice(5, 0, '-')
        return arr.join('')
    }
});

Vue.filter('cpfCnpj', value => {
    if(value) {
        if (value.length <= 11) {
            value = value.padStart(11, '0');
            value = value.replace(/(\w{3})(\w{3})(\w{3})(\w{2})/g,'$1.$2.$3-$4');
        } else {
            value = value.padStart(14, '0');
			value = value.replace(/^(\w{2})(\w{3})(\w{3})(\w{4})(\d{2})/, '$1.$2.$3/$4-$5');
        }
    }
    return value;
});

Vue.filter('cnpjRaiz', value => {
    if(value) {
        value = value.padStart(8, '0');
        value = value.replace(/^(\w{2})(\w{3})(\w{3})/, '$1.$2.$3');
    }
    return value;
});

Vue.filter('numeroUnico', value => {
    if(value == null || value == ""){
        return value;
    }
    return value.padStart(20, '0').replace(/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/g,'$1-$2-$3.$4.$5.$6');
});